import React from 'react';

const ContactInfo = () => {
  return (
    <section id="contact-info">
      <h1>Elérhetőségek</h1>

      <ul>
        <li>
          <a href="mailto: varosgazdalkodas@kjvgkft.hu">Email: varosgazdalkodas@kjvgkft.hu</a>
        </li>

        <li>
          <a href="tel: +36-59-520-210">Telefon: +36 59/520-210</a>
        </li>

        <li>
          <p>Fax: +36 59/520-219</p>
        </li>

      </ul>

    </section >
  );
};

export default ContactInfo;